/** @format */
import Diagram_kyeongbok from '@/assets/diagram/kyeongbok.png';
import Diagram_templestay from '@/assets/diagram/templestay.png';
import Diagram_bluehouse from '@/assets/diagram/bluehouse.png';
import Diagram_warmemorial from '@/assets/diagram/warmemorial.png';
import Diagram_museumtown from '@/assets/diagram/museumtown.png';
import Diagram_arttown from '@/assets/diagram/arttown.png';
import Diagram_seoul284 from '@/assets/diagram/seoul284.png';
import Diagram_koreanstylehouse from '@/assets/diagram/koreanstylehouse.png';
import Diagram_seoul_lib from '@/assets/diagram/seoul_lib.png';
import Diagram_changduk from '@/assets/diagram/changduk.png';

import Title_kyeongbok from '@/assets/title/kr/kyeongbok.png';
import Title_templestay from '@/assets/title/kr/templestay.png';
import Title_bluehouse from '@/assets/title/kr/bluehouse.png';
import Title_warmemorial from '@/assets/title/kr/warmemorial.png';
import Title_museumtown from '@/assets/title/kr/museumtown.png';
import Title_arttown from '@/assets/title/kr/arttown.png';
import Title_seoul284 from '@/assets/title/kr/seoul284.png';
import Title_koreanstylehouse from '@/assets/title/kr/koreanstylehouse.png';
import Title_seoul_lib from '@/assets/title/kr/seoul_lib.png';
import Title_changduk from '@/assets/title/kr/changduk.png';

export default {
    kyeongbok: {
        diagram: Diagram_kyeongbok,
        title: Title_kyeongbok,
        msg: `<p>경복궁은 조선 왕조 제일의 법궁으로, 북으로 북악산을 기대어 자리 잡았고 정문인 광화문 앞으로는 넓은 육조거리(지금의 세종로)가 펼쳐져, 왕도인 한양(서울) 도시 계획의 중심이기도 하다.</p>

<p>1395년 태조 이성계가 창건하였고, 1592년 임진흥선대원군이 주도한 중건된 경복궁은 500여 동의 건물들이 미로같이 빼곡히 들어선 웅장한 모습을 보여주었으나, 왜란으로 불타 없어졌다가, 고종 때인 1867년 중건 되었다.</p>

<p>궁궐 안에는 왕과 관리들의 정무 시설, 왕족들의 생활 공간, 휴식을 위한 후원 공간이 조성되어있으며, 또한 왕비의 중궁, 세자의 동궁, 고종이 만든 건청궁 등 궁궐안에 다시 여러 작은 궁들이 복잡하게 모인 곳 이기도 하다. 그러나 일제 강점기에 거의 대부분의 건물들을 철거하여 근정전 등 극히 일부 중심 건물만 남았고, 조선 총독부 청사를 지어 궁궐 자체를 가려버렸다. 다행히 1990년부터 본격적인 복원 사업이 추진되어 총독부 건물을 철거하고 흥례문 일원을 복원하였으며, 왕과 왕비의 침전, 동궁, 건청궁, 태원전 일원의 모습을 되찾고 있다.</p>`,
        scene: 'scene_kyeongbok',
        vr_url:
            'https://look360.kr/vr/2020sitm_royalpalace/2020sitm_royalpalace',
        site_url: 'http://www.royalpalace.go.kr',
        narration: 'kyeongbok',
        title_maxwidth: 267,
    },
    templestay: {
        diagram: Diagram_templestay,
        title: Title_templestay,
        msg: `<p>우리나라 불교의 최대 종파인 조계종의 대표 사찰이다. 1910년 한용운 등이 주축이 되어 세운 ‘각황사’가 1938년 대대적인 중수를 거쳐 ‘태고사’로 불리었고 1954년 일제의 잔재를 제거하는 불교정화운동을 통해 현재의 이름으로 자리 잡았다. ‘조계(曹溪)’라는 명칭은 중국 선불교의 6대 조사로 꼽히며 수행의 지표로 추앙받는 혜능대사가 머물렀던 조계산에서 가져왔다.</p>

<p>중심 건물인 대웅전은 태고사 중건 당시 전북 정읍의 사찰 건물을 그대로 가져온 것으로 커다란 기둥이 고풍스러운 화려함을 자랑한다. 앞마당에 위치한 칠층석탑에는 부처님의 진신사리가 봉안되어 있고 500년 수령의 백송과 400년의 회화나무가 대웅전 건물을 호위하듯 감싸고 있다. 건물 주변으로 사찰음식점과 찻집, 불교용품을 판매하는 상점들이 어우러져 불교의 거리를 만든다. 함께 있는 불교중앙박물관은 전국 사찰에서 보관하기 어려운 불교문화재가 관리, 전시되는 곳으로 진귀한 한국 불교미술의 보물들을 만날 수 있다.</p>

<p>조계사에서는 불자들과 방문객들 사이에 어떤 벽도 없으며, 분주한 가운데 마음을 가라앉혀 고요함을 놓치지 않고, 치열하게 살되 따뜻함을 잃지 않도록, 그저 함께하고자 한다면 곧바로 함께할 수 있는 템플스테이를 운영하고 있다.</p>`,
        scene: 'scene_templestay',
        vr_url: 'https://look360.kr/vr/2020sitm_jogyesa/2020sitm_jogyesa',
        site_url: 'http://www.jogyesa.kr',
        narration: 'templestay',
    },
    bluehouse: {
        diagram: Diagram_bluehouse,
        title: Title_bluehouse,
        msg: `<p>청와대(靑瓦臺)는 ‘푸른 기왓장으로 지붕을 올린 건물’이라는 뜻이다. 대한민국 대통령이 일하고 생활하는 공간이다. 고려시대 궁궐터로 사용된 옛 청와대 터부터 현재의 청와대 모습을 갖추기까지 변화과정을 일목요연하게 확인할 수 있다.</p>

<p>청와대 앞마당에 위치한 청와대 사랑채는 한국의 관광지, 청와대 및 역대 대통령 발자취를 이해할 수 있는 종합관광홍보관으로, 1층은 한국관광전시관·기념품점·쉼터로, 2층은 청와대관·국민소통체험관으로 구성되어 있다.</p>

<p>한국관광전시관은 두 가지 테마로 구성되어 있다. 청와대 속 궁금한 이야기를 비롯해 역대 대통령의 발자취를 찾아보는 전시관과 아름다운 한국의 문화와 여행지를 소개하는 전시관이다. 미국 영부인 멜라니아 트럼프와 김정숙 여사가 함께 거닌 청와대 ‘불로문(不老門)’이 두 공간을 이어줍니다.</p>

<p>청와대관은 문재인 대통령과 현재의 청와대를 소개하고있다. 현 정부의 과거, 현재, 미래 비전을 공유할 수 있는 역사기념관이자 문화홍보관으로써, 실제 대통령 집무실을 그대로 재현한 공간이다.</p>`,
        scene: 'scene_bluehouse',
        vr_url:
            'https://look360.kr/vr/2020sitm_cwdsarangchae/2020sitm_cwdsarangchae',
        site_url: 'https://cwdsarangchae.kr',
        narration: 'bluehouse',
        title_maxwidth: 486,
    },
    warmemorial: {
        diagram: Diagram_warmemorial,
        title: Title_warmemorial,
        msg: `<p>전쟁의 아픈 상처를 추모하고 평화를 기원하는 전시관이다. 약 82.6㎢의 대지 위에 1994년 완공된 기념관은 1만점이 넘는 전쟁 관련 기념물을 전시하고 있는 대규모 공간이다. 정문 좌우로 광개토대왕비의 실물 모형과 국군장교와 인민군 병사가 포옹하는 모습의 형제의 상이 자리 잡고 있으며 선사시대 청동검과 생명의 나무가 어우러지는 모습의 상징탑이 중앙으로 우뚝 서 있다. 형제의 상은 한국전쟁 당시, 서로에게 총부리를 겨눈 적으로 만난 실제 형제의 이야기를 담고 있는 조형물이다.</p>

<p>평화의 광장을 지나 이어지는 건물은 6개의 전시구역으로 나뉘는 실내 전시장이다. 물과 빛이 어우러지는 호국추모실은 창군 이후 전사한 17만 명의 이름을 담은 장부를 보관하는 엄숙한 공간이다. 선사시대부터 대한제국까지 이 땅에서 사용된 수많은 무기들을 전시하고 있는 전쟁역사실을 시작으로 6·25전쟁실, 해외파병실, 국군발전실 등에서 한국전쟁을 시작으로 세계로 파견되어 활약하고 있는 국군과 발전하는 군사 장비들을 살펴볼 수 있다.</p>`,
        scene: 'scene_warmemorial',
        vr_url: 'https://look360.kr/vr/2020sitm_warmemo/2020sitm_warmemo',
        site_url: 'http://www.warmemo.or.kr',
        narration: 'warmemorial',
        title_maxwidth: 421,
    },
    museumtown: {
        diagram: Diagram_museumtown,
        title: Title_museumtown,
        msg: `<p>돈의문 박물관마을은 전면 철거 후 공원으로 만드는게 원례 계획이었지만, 그 역사적 가치를 인정받아 서울형 도시재생방식을 선택하여 2017년 마을 전체가 박물관으로 조성된 역사 문화 공간이다. 애초 예술가를 위한 전시 공간으로 활용돼 왔지만, 2019년 4월부터 전시·행사·체험 등이 열리는 시민참여형 공간으로 재탄생했다. 공간은 마을전시관(16개동), 체험교육관(9개동), 마을창작소(9개동) 등 3개로 구성돼 있다.</p>
 
<p>마을 핵심 공간인 '마을전시관'에는 3·1운동과 대한민국 임시정부 수립 100주년 기념 테마 전시관인 '독립운동가의 집', 1960~80년대 가정집을 복원한 '생활사 전시관', 시민 소장품을 전시한 '시민갤러리' 등이 조성돼 있다. 또 전통문화 명인들이 운영하는 '체험교육관'은 한지공예, 서예, 자수공예, 닥종이공방, 차·가배 등 전통한옥에 어울리는 체험행사를 제공하는 공간이다. 아울러 공모를 통해 모집된 운영자들이 운영하는 '마을창작소'는 시대별 골목놀이 방법과 놀이기구를 전시·체험할 수 있는 공간이다. 이 밖에 마을 마당과 골목길 등 외부 공간을 활용한 다양한 행사가 열려 관람객에게 풍성한 즐길 거리를 제공한다.</p>`,
        scene: 'scene_museumtown',
        vr_url: 'https://look360.kr/vr/2020sitm_dmvillage/2020sitm_dmvillage',
        site_url: 'http://dmvillage.info',
        narration: 'museumtown',
    },
    arttown: {
        diagram: Diagram_arttown,
        title: Title_arttown,
        msg: `<p>문래동은 일제강점기에 방적공장이 들어서면서 공장과의 인연이 깊어진 곳이다. 당시 방적기계를 '물래'라고 부르면서 이곳의 지명인 '문래동'이 자리 잡혔다고 한다. 이후 철강공장, 철제상이 이곳에 밀집했으며 현재는 예술가들이 이곳에 몰리면서 예술과 철공소가 공존하는 공간으로 거듭나고 있다.</p>

<p>골목길 외에는 적당한 단어가 떠오르지 않는 공간에 어떤 규칙도, 얽매임도 없이 벽화가 그려져 있으며, 골목길을 걷다가 꺾인 쪽으로 몸을 돌리는 순간마다 돌발적인 풍경이 곳곳에 있다. 지붕 없는 미술관이라고 불러도 괜찮을 것 같다.</p>

<p>서울의 오래된 공업단지는 농업보다 공업이 우대받기 시작한 근대화의 흔적으로, 지금보다 공장들이 집약된 70년대 문래동은 노동자와 기계 그리고 철의 세계였다. 지금까지 그 세계를 엿볼 수 있는 풍경이 골목 구석구석에 남아있다. 그 위로 누군가 붓을 그어 채색을 하면서 서울의 흔한 동네가 아닌 예술가의 손에 의해 독특한 동네로 변화해온 공간이다.</p>`,
        scene: 'scene_arttown',
        vr_url:
            'https://look360.kr/vr/2020sitm_mullaertrefactory/2020sitm_mullaertrefactory',
        site_url: '',
        narration: 'arttown',
    },
    seoul284: {
        diagram: Diagram_seoul284,
        title: Title_seoul284,
        msg: `<p>KTX 신역사 개통 이후 기차역으로서의 기능이 소멸한 구서울역사를 원형 복원해 복합문화공간으로 조성, 2012년 4월 공식 출범했다. 서울특별시 중구 통일로 1번지에 위치해 있다.</p>

<p>스위스 루체른 역을 모델로 삼았다는 이 웅장한 벽돌 건물은 한때 식민지의 관문이었다. 일본은 이곳을 통해 만주뿐 아니라 모스크바와 베를린까지 연결시키려고 했다. 패전으로 일제의 야망은 사라졌으나 서울역은 여전히 한반도 교통의 중심이었다. 10여 년 전 새로운 역사가 건축되면서 옛 서울역사는 '문화역서울 284'라는 이름의 복합문화공간으로 다시 태어났다.</p>

<p>명칭은 대국민 공모를 통해 만들어졌는데 「284」는 구서울역사가 사적 제284호의 국가지정 문화재라는 것을 의미한다. 사적의 모습과 가치를 보존하는 동시에 다양한 문화가 교차하는 역의 상징성을 살린 공간으로, 현재 강연, 공연, 전시, 연구 등 다양한 프로그램이 열리고 있다.</p>`,
        scene: 'scene_seoul284',
        vr_url: 'https://look360.kr/vr/2020sitm_seoul284/2020sitm_seoul284',
        site_url: 'https://www.seoul284.org',
        narration: 'seoul284',
    },
    koreanstylehouse: {
        diagram: Diagram_koreanstylehouse,
        title: Title_koreanstylehouse,
        msg: `<p>북촌은 조선시대에 조성된 양반층 주거지로서 1920년대까지 그다지 큰 변화가 없었는데, 1930년대에 서울의 행정구역이 확장되고, 도시구조도 근대적으로 변형되면서 변화가 일어났다. 주택경영회사들이 북촌의 대형 필지와 임야를 매입하여, 그 자리에 중소 규모의 한옥들을 집단적으로 건설하였는데, 현재 한옥들이 밀집되어있는 가회동, 삼청동, 계동의 한옥주거지들이 모두 이 시기에 형성되었다.</p>

<p>이 북촌 한옥마을에 위치한 한옥 문화원은 한옥마을로 유명한 서울 북촌에 있는 한옥 교육 전문 기관으로, 2000년 3월 한옥의 가치와 아름다움을 널리 알리고, 계승·발전시키기 위하여 설립되었다. 한옥 문화원은 한옥의 법식과 기법, 기술사 연구를 통해 전문인을 양성할 뿐만 아니라 다양한 강좌를 진행하고, 50여 명의 문화재, 전통문화 전문가들이 후학 지도에 나서고 있다. 직접 건축사업단을 운영하며, 2000년 영국 대영박물관(British Museum)에 한옥 사랑방 기술지도를 비롯해 북촌한옥마을 게스트하우스 등 한옥 신개축, 한옥형 리모델링에 적극 참여하고 있다.</p>`,
        scene: 'scene_koreanstylehouse',
        vr_url:
            'https://look360.kr/vr/2020sitm_hanok_seoul/2020sitm_hanok_seoul',
        site_url: 'http://www.hanok.org',
        narration: 'koreanstylehouse',
    },
    changduk: {
        diagram: Diagram_changduk,
        title: Title_changduk,
        msg: `<p>궁궐의 정원이라는 뜻에서 금원(禁苑), 궁궐의 북쪽에 있다하여 북원(北苑),<br class='pc_only' />
                            또 뒤쪽에 위치한 정원이라는 뜻에서 후원이라 불러왔다.</p><p>후원은 엄밀히 말해 창덕궁의 후원이지만 이 후원이 자리 잡고 있는 곳이 창덕궁과 창경궁의 뒤쪽이 되어 자연히 두 궁궐에서 공유하고 있다. 후원은 모두 5개의 큰 지역으로 구성되었다. 첫째, 부용지를 중심으로 그 주변의 부용정, 주합루, 영화당, 서향각, 등의 건물들이 늘어선 지역으로 이 지역의 등성이 너머 둘째 지역과 접해 있다. 둘째, 애련지와 애련정, 그리고 연경당이 들어선 지역으로 이 영역과 다시 고개 너머의 세 번째 지역과 연이어 있다. 셋째, 관람정과 존덕정과 폄우사가 있는 지역이다.</p>
                        
                        <p>그리고 이 지역은 산등성이 너머의 마지막 옥류천 지역과 연이어져 있다.<br class='pc_only' />
                        넷째, 옥류천을 중심으로 소요정, 청의정, 태극정 등이 늘어선 지역이다.<br class='pc_only' />
                        다섯째, 서북방의 신선원전(新璿源殿)을 지은 지역이다.</p>`,
        scene: 'scene_changduk_buyongji',
        vr_url: 'https://look360.kr/vr/2020sitm_cdg/2020sitm_cdg',
        site_url: 'http://www.cdg.go.kr/',
        narration: 'changduk',
    },
    seoul_lib: {
        diagram: Diagram_seoul_lib,
        title: Title_seoul_lib,
        msg: `<p>서울특별시의 기록과 정보를 시민과 공유하는 지식공간입니다. 소통의 상징 서울광장을 품고 있는 서울기록 문화관은 서울시민과 서울특별시의 소통공간이며, 서울의 과거와 현재 그리고 미래를 잇는 역사 공간이다.</p>
                    
                    <p>전시관은 2014년 진행한 “서울광장 기록수집 및 콘텐츠개발 사업”과 2015년도 서울도서관에서 시민들에게 공개한 “서울광장 기록전시 사업”을 종합적으로 정리하고 현행화 시킨 기록전시로, 스토리텔링을 위해 설정한 가상의 서울 시민인 구보씨가 성장하면서 겪게 되는 개인의 역사와 우리의 현대사가 서울광장을 중심으로 전개된다.</p>
                    
                    <p>옛 시장실은 해방 이후부터 2008년 5월까지 60여 년 동안 역대 서울시장이 사용했던 집무공간이다. 시장실은 구 시청사 3층 정중앙에 위치하며 집무실과 접견실 등으로 구성되어 있었으며, 복원공간에서는 그 당시의 옛집기, 가구 등을 그대로 재현해놓고 있다.</p>`,
        scene: 'scene_seoul_lib',
        vr_url: 'https://look360.kr/vr/2020sitm_lib_seoul/2020sitm_lib_seoul',
        site_url: 'https://lib.seoul.go.kr/rwww/html/ko/seoulArchRoom.jsp',
        narration: 'seoul_lib',
    },
};
/*
https://look360.kr/project/ioconvex_intro/#/kyeongbok
https://look360.kr/project/ioconvex_intro/#/templestay
https://look360.kr/project/ioconvex_intro/#/bluehouse
https://look360.kr/project/ioconvex_intro/#/warmemorial
https://look360.kr/project/ioconvex_intro/#/museumtown
https://look360.kr/project/ioconvex_intro/#/arttown
https://look360.kr/project/ioconvex_intro/#/seoul284
https://look360.kr/project/ioconvex_intro/#/koreanstylehouse
https://look360.kr/project/ioconvex_intro/#/changduk
https://look360.kr/project/ioconvex_intro/#/seoul_lib
*/
